import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class PurchaseCheckoutUseCase extends UseCase {
  constructor({repository, getCurrentUserService, purchaseCheckoutError}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._purchaseCheckoutError = purchaseCheckoutError
  }

  _throwPurchaseCheckoutError(message) {
    throw this._purchaseCheckoutError(`[PurchaseCheckoutErrorsRepository#get] ${message}`)
  }

  _getCurrentUser = async () => this._getCurrentUserService.execute()

  _getUserId = async () => {
    const currentUser = await this._getCurrentUser()
    return currentUser ? currentUser.getId() : this._throwPurchaseCheckoutError('Unknown user ID')
  }

  /**
   * @return {Promise<Object, Error>}
   */
  async execute({paymentMethod, orderId, returnUrl, paymentsDefaultConfig}) {
    const userId = await this._getUserId()
    const paymentInformation = {
      paymentMethod,
      paymentsDefaultConfig
    }
    const purchaseResponse = await this._repository.purchase({
      userId,
      paymentInformation,
      orderId,
      returnUrl
    })
    return purchaseResponse.toJSON()
  }
}
